import { useState, useContext, useRef } from 'react';
import ExpandableMapControl from 'core/ui/mapping/expandable-map-control';
import {poi_search, geo_search, remove_html} from '../core/here_api'

import SessionContext from 'SessionContext'

import { Button, Input } from 'reactstrap';

const MapSearch = (props) => {
  const context = useContext(SessionContext);
  const [searchText, setSearchText] = useState(undefined);
  const [geocodeResults, setGeocodeResults] = useState([]);
  const [locationResults, setLocationResults] = useState([]);
  const [poiResults, setPoiResults] = useState([]);
  const searchbox = useRef(null);

  function flyTo(loc) {
    if (!loc) { return; }
    context.crossfilterStore.add_adhoc_point(loc);
    props.map?.flyTo({center: [parseFloat(loc.lng), parseFloat(loc.lat)], zoom: 12});
  }

  function onChangeSearch(ev) {
    setSearchText(ev.target.value);
  }

  function onExpand(){
    searchbox.current?.focus();
  }

  function onKeyPressed(ev) {
    if(ev.key ==='Enter') {
      onSearchMap();
    }
  }
  function onSearchMap() {
    if (!searchText) {
      return;
    }

    const geocode_promise = geo_search(searchText, context.appState.identity.here_api_key);
    const location_promise = locationSearch(searchText);
    const poi_promise = poi_search(searchText, props.map, context.appState.identity.here_api_key);

    Promise.all([geocode_promise, location_promise, poi_promise]
    ).then(([geocodeResults, locationResults, poiResults]) => {
      const geos = geocodeResults.items.map((result) =>{
         return {
            'name': result.address.label.replace(', United States', ''),
            'lat': result.position.lat,
            'lng': result.position.lng
            }
          }).flat();

      const pois = poiResults.items.filter(r => r.position).map(result => ({
            'name': result.title,
            'extra': result.resultType,
            'lat': result.position.lat,
            'lng': result.position.lng
          }));

      setGeocodeResults(geos);
      setLocationResults(locationResults);
      setPoiResults(pois);
    }).catch((err) => {
      console.error('Map search failed:', err);
    });
  }

  function locationSearch(searchText) {
    return context.query('location/search', {'searchText': searchText})
          .then((locations) => {
            if(locations.length >0) {
              return locations;
            }
            else {
              return [];
            }
          });
  }

  return (
      <ExpandableMapControl onExpand={onExpand}
                            openButton={<i className='fa fa-magnifying-glass' />}>
        <div className='map-search'>
          <header>
            <i className='fa fa-magnifying-glass' />
            <Input type='search' placeholder='Search' onChange={onChangeSearch} onKeyDown={onKeyPressed}
                    ref={searchbox} />
            <Button size="sm" className='search-button' type='submit' onClick={onSearchMap}>Find</Button>
          </header>
          <div className='results'>
            {locationResults.length > 0 &&
            <>
              <h4>My Locations</h4>
              <ul> {
                locationResults.map((loc, idx) =>
                      <li key={idx} onClick={() => flyTo(loc)}>
                        <span className='result-name'>{remove_html(loc.name)}</span>
                        <span>{loc.extra}</span>
                      </li>
                )}
              </ul>
            </>
            }
            {geocodeResults.length > 0 &&
            <>
              <h4>Search Results</h4>
              <ul>
                {
                  geocodeResults.map((result, idx) =>
                      <li key={idx} onClick={() => flyTo(result)}>
                        <span className='result-name'>{remove_html(result.name)}</span>
                        <span>{result.extra}</span>
                      </li>

                  )}
              </ul>
            </>
            }

            {poiResults.length > 0 &&
            <>
              <h4>Points of Interest</h4>
              <ul>
                {
                  poiResults.map((poi, idx) =>
                      <li key={idx} onClick={() => flyTo(poi)}>
                        <span className='result-name'>{poi.name}</span>
                        <span className='result-extra'>{remove_html(poi.extra)}</span>
                      </li>
                  )}
              </ul>
            </>
            }

            {/*<h4>Zip Codes<sup>&trade;</sup></h4>*/}
            {/*<ul>*/}
            {/*  <li>30096</li>*/}
            {/*</ul>*/}
            {(geocodeResults.length > 0 || poiResults.length > 0) &&
            <footer className='footer'>Search powered by
              <a className='here-logo' href='https://www.here.com/' title='HERE Technologies' target='_blank' rel='noopener noreferrer'>HERE&trade;</a>
            </footer>
            }
          </div>
        </div>
      </ExpandableMapControl>
  );
}
export default MapSearch;
